export function computeItemPrice({ variant, photosQuantity, roundedCorner, domain, role }) {
  if (!variant) return 0;
  const key = `${domain}:${role}`;
  const priceEntry = variant.domain_prices?.[key];
  if (!priceEntry) return 0;

  const ppu = variant.photos_per_unit || 1;
  const units = Math.floor(photosQuantity / ppu);

  const baseUnit = roundedCorner
    ? (priceEntry.rounded_corner_price ?? priceEntry.base_price)
    : priceEntry.base_price;

  const bulkQty = Number(variant.bulk_quantity) || 0;
  const useBulk = bulkQty > 0 && units >= bulkQty && Number(priceEntry.bulk_price) > 0;
  const unitPrice = useBulk ? priceEntry.bulk_price : baseUnit;

  return unitPrice * units;
}

export function computeAdjustmentPrice({ adjustment, variant, photosQuantity }) {
  if (!adjustment || !variant) return 0;
  const ppu = variant.photos_per_unit || 1;
  const units = Math.floor(Number(photosQuantity) / ppu);
  if (units <= 0) return 0;
  return (adjustment.price_delta || 0) * units;
}
